import { render, staticRenderFns } from "./TextFragment.vue?vue&type=template&id=c7cdde6a&"
import script from "./TextFragment.vue?vue&type=script&lang=js&"
export * from "./TextFragment.vue?vue&type=script&lang=js&"
import style0 from "./TextFragment.vue?vue&type=style&index=0&id=c7cdde6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports